import React from 'react';
import HeroSection from '../components/HeroSection';
import PainSection from '../components/PainSection';
import CoreValueSection from '../components/CoreValueSection';
import SocialProofSection from '../components/SocialProofSection';
import HowItWorksSection from '../components/HowItWorksSection';
import ProductAreasSection from '../components/ProductAreasSection';
import TeamPortalSection from '../components/TeamPortalSection';
import FeaturesSection from '../components/FeaturesSection';
import ReceiptScanningSection from '../components/ReceiptScanningSection';
import ContactForm from '../components/ContactForm';
import CTASection from '../components/CTASection';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div>
      <HeroSection />
      <PainSection />
      <CoreValueSection />
      <SocialProofSection />
      <HowItWorksSection />
      <ProductAreasSection />
      <TeamPortalSection />
      <FeaturesSection />
      <ReceiptScanningSection />
      <ContactForm />
      <CTASection />
      <Footer />
    </div>
  );
};

export default Home;
